"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var VirtualMenuItem_1 = __importDefault(require("./VirtualMenuItem"));
exports.default = (function (items, value, onChange) {
    var RowRenderer = function (_a) {
        var key = _a.key, index = _a.index, style = _a.style;
        var item = items && items[index];
        if (!item) {
            return react_1.default.createElement("div", null);
        }
        var selected = item && value === item.key;
        return (react_1.default.createElement(VirtualMenuItem_1.default, { key: key, item: item, style: style, selected: selected, onChange: onChange }));
    };
    return RowRenderer;
});
